import React from 'react';
import { Link } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';
import { useAppContext } from '../context/AppContext';

const WishlistSidebar = () => {
  const { 
    wishlistSidebarOpen, 
    toggleWishlistSidebar,
    wishlist = [],  
    products = [],  
    toggleWishlist
  } = useAppContext();


  const wishlistItems = Array.isArray(products) && Array.isArray(wishlist)
    ? products.filter(product => wishlist.includes(product.id))
    : [];

  if (!wishlistSidebarOpen) return null;

  return (
    <div className="wishlist-sidebar active">
      <div className="wishlist-header">
        <h3>Your Wishlist</h3>
        <button 
          className="close-wishlist" 
          onClick={toggleWishlistSidebar}
          aria-label="Close wishlist"
        >
          <FaTimes />
        </button>
      </div>
      <div id="wishlistItems">
        {wishlistItems.length > 0 ? (
          wishlistItems.map(item => (
            <div className="wishlist-item" key={item.id}>
              <div className="wishlist-item-img">
                <img 
                  src={item.image} 
                  alt={item.name} 
                  loading="lazy" 
                />
              </div>
              <div className="wishlist-item-info">
                <h4>{item.name}</h4>
                <div className="wishlist-item-price">
                  ${item.price?.toFixed(2) || '0.00'}  // Safely handle price
                </div>
                <div className="wishlist-item-actions">
                  <Link 
                    to={`/product/${item.id}`} 
                    className="btn btn-sm btn-outline"
                    onClick={toggleWishlistSidebar}  
                  >
                    View
                  </Link>
                  <button 
                    className="btn btn-sm remove-from-wishlist"
                    onClick={() => toggleWishlist?.(item.id)}  
                    aria-label={`Remove ${item.name} from wishlist`}
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="wishlist-empty">
            <p>Your wishlist is empty</p>
            <Link 
              to="/products" 
              className="btn"
              onClick={toggleWishlistSidebar}  
            >
              Browse Products
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default WishlistSidebar;